module.exports = __webpack_public_path__ + "img/robotIcon-swiper-img6.0aa5ef19.png";